<form [formGroup]="form">
    <ion-item-divider color="light">
        <ion-label>{{ dividerTitle  | translate }}</ion-label>
    </ion-item-divider>

    <!-- Set Type -->
    <ion-item>
        <ion-select label="{{ 'Set type' | translate }}" label-placement="stacked" #setType interface="popover" formControlName="setType">
            <ion-select-option value="STANDARD">{{'Standard' | translate}}</ion-select-option>
            <ion-select-option value="TIEBREAK">{{'Tiebreak' | translate}}</ion-select-option>
            <ion-select-option value="TIMED">{{'Timed' | translate}}</ion-select-option>
        </ion-select>
    </ion-item>

    <ion-row>
        <ion-col>
            <!-- Number of Sets-->
            <ion-item>
                <ion-select label="{{ 'Sets' | translate }}" label-placement="stacked" interface="popover" formControlName="numberOfSets">
                    <ion-select-option value="1">1</ion-select-option>
                    <ion-select-option *ngIf="setType.value === 'TIMED'" value="2">2</ion-select-option>
                    <ion-select-option value="3">3</ion-select-option>
                    <ion-select-option *ngIf="setType.value === 'TIMED'" value="4">4</ion-select-option>
                    <ion-select-option value="5">5</ion-select-option>
                    <ion-select-option *ngIf="setType.value === 'TIMED'" value="9">9</ion-select-option>

                </ion-select>
            </ion-item>
        </ion-col>

        <ion-col [hidden]="setType.value !== 'TIMED'">
            <!-- Number of minutes for timbed matches-->
            <ion-item>
                <ion-input label="{{ 'Number of minutes' | translate }}" label-placement="floating" type="number" formControlName="numberOfMinutes"></ion-input>
            </ion-item>
        </ion-col>

        <ion-col [hidden]="setType.value === 'TIEBREAK' || setType.value === 'TIMED'">
            <!-- Number of Games-->
            <ion-item>
                <ion-select label="{{ 'Games per set' | translate }}" label-placement="stacked" #gamesPerSet interface="popover" formControlName="numberOfGames" (ionChange)="onNumberOfGamesChange($event)">
                    <ion-select-option value="4">4</ion-select-option>
                    <ion-select-option value="5">5</ion-select-option>
                    <ion-select-option value="6">6</ion-select-option>
                    <ion-select-option value="7">7</ion-select-option>
                    <ion-select-option value="8">8</ion-select-option>
                    <ion-select-option value="9">9</ion-select-option>
                    <ion-select-option value="10">10</ion-select-option>
                    <ion-select-option value="16">16</ion-select-option>
                </ion-select>
            </ion-item>
        </ion-col>

    </ion-row>

    <ion-row>
        <ion-col [hidden]="setType.value === 'TIEBREAK' || setType.value === 'TIMED'">
            <!-- Tiebreak at-->
            <ion-item>
                <ion-select label="{{ 'Tiebreak at' | translate }}" label-placement="stacked" interface="popover" formControlName="tiebreakAt">
                    <ion-select-option *ngIf="gamesPerSet.value === '4'" value="3">3-3</ion-select-option>
                    <ion-select-option *ngIf="gamesPerSet.value === '4' || gamesPerSet.value === '5'" value="4">4-4</ion-select-option>
                    <ion-select-option *ngIf="gamesPerSet.value === '6' || gamesPerSet.value === '5'" value="5">5-5</ion-select-option>
                    <ion-select-option *ngIf="gamesPerSet.value === '6' || gamesPerSet.value === '7'" value="6">6-6</ion-select-option>
                    <ion-select-option *ngIf="gamesPerSet.value === '8'" value="7">7-7</ion-select-option>
                    <ion-select-option *ngIf="gamesPerSet.value === '8' || gamesPerSet.value === '9'" value="8">8-8</ion-select-option>
                    <ion-select-option *ngIf="gamesPerSet.value === '10'" value="9">9-9</ion-select-option>
                    <ion-select-option *ngIf="gamesPerSet.value === '10'" value="10">10-10</ion-select-option>
                    <ion-select-option *ngIf="gamesPerSet.value === '16'" value="15">15-15</ion-select-option>
                </ion-select>
            </ion-item>
        </ion-col>

        <ion-col [hidden]="setType.value === 'TIMED'">
            <!-- Tiebreak type-->
            <ion-item>
                <ion-select label="{{ 'Tiebreak type' | translate }}" label-placement="stacked" interface="popover" formControlName="tiebreakType">
                    <ion-select-option value="TB10" [hidden]="setType.value === 'STANDARD'">to 10</ion-select-option>
                    <ion-select-option value="TB7">to 7</ion-select-option>
                    <ion-select-option value="TB5">9 points</ion-select-option>
                    <ion-select-option value="TB7P">13 points</ion-select-option>
                </ion-select>
            </ion-item>
        </ion-col>

    </ion-row>

    <ion-row [hidden]="setType.value === 'TIEBREAK'">

        <ion-col [hidden]="!showLastSet() || setType.value === 'TIMED'">
            <!-- Last set-->
            <ion-item>
                <ion-select label="{{ 'Last set' | translate }}" label-placement="stacked" interface="popover" formControlName="lastSet">
                    <ion-select-option value="">{{'Regular' | translate}}</ion-select-option>
                    <ion-select-option value="TB10">{{'10pt tiebreak' | translate}}</ion-select-option>
                    <ion-select-option value="TB7">{{'7pt tiebreak' | translate}}</ion-select-option>
                    <ion-select-option value="WB2">{{'Win by 2' | translate}}</ion-select-option>
                    <ion-select-option *ngIf="form?.get('numberOfSets')?.value > 1" value="TB10@6">
                        {{'10pt tiebreak at 6–6' | translate}}
                    </ion-select-option>
                </ion-select>
            </ion-item>
        </ion-col>

        <ion-col [hidden]="true">
            <!-- <ion-col [hidden]="setType.value !== 'TIMED'"> -->
            <ion-item>
                <ion-select #gamesOrPoints label="{{ 'Game or points' | translate }}" label-placement="stacked" interface="popover" formControlName="gamesOrPoints">
                    <ion-select-option value="G">{{'Games' | translate}}</ion-select-option>
                    <ion-select-option value="P">{{'Points' | translate}}</ion-select-option>
                </ion-select>
            </ion-item>
        </ion-col>

        <ion-col [hidden]="setType.value === 'TIMED' && gamesOrPoints.value === 'P'">
            <!-- Ads -->
            <ion-item>
                <ion-toggle justify="space-between" formControlName="ads">{{ 'With Ads' | translate }}</ion-toggle>
            </ion-item>
        </ion-col>
    </ion-row>
</form>

<ion-text *ngIf="resetLastSet" color="danger" class="ion-padding-start">
    <span style="font-size: small;">{{'Changing last set type will restart the set to 0-0' | translate}}</span>
</ion-text>